<template>
  <a-card title="证书查询" style="min-height:500px;">
    <a-input-search
      placeholder="请输入证书编号"
      enter-button="查询"
      size="large"
      v-model="awardCode"
      @search="onSearch"
    />
    <a-divider></a-divider>
   
    <div v-if="fileUrl">
      <a :href="fileUrl" target="_blank">
        <img :src="fileUrl" alt="" style="max-width:100%;">
      </a>
      
    </div>
  </a-card>
</template>

<script>
import { getAction } from "@/api/manage";
import QrCode from "@/components/tools/QrCode";

export default {
  name: "CertQuery",
  components: {
    QrCode,
  },
  data() {
    return {
      awardInfo: {},
      awardCode: "",
      fileUrl: '',
    };
  },
  created() {
    let id = this.$route.query.id;
    let awardCode = this.$route.query.code
    if (id || awardCode) {
      this.getAwardInfo(id, awardCode);
    }
    // if(window.location.pathname == "/cert/query"){
    //   window.location.href = "/cert/query.html" + window.location.search
    // }
  },
  methods: {
    onSearch(awardCode) {
      this.getAwardInfo(undefined, awardCode);
    },
    getAwardInfo(id, awardCode) {
      this.awardInfo = {}
      getAction("/teaching/teachingAwardGrant/queryAward", {
        id: id,
        awardCode: awardCode,
      }).then((res) => {
        if (res.success) {
          this.awardInfo = res.result;
          this.fileUrl = res.result.awardFile_url + "?t="+new Date().getTime()
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style>
</style>